import { useState } from 'react';
import axios from 'axios';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Lock } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PortalSetupPassword = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error('La contraseña debe tener al menos 6 caracteres');
      return;
    }
    if (password !== confirm) {
      toast.error('Las contraseñas no coinciden');
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API}/portal/auth/setup-password`, { token, password });
      toast.success('Contraseña configurada. Inicia sesión.');
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'No se pudo configurar la contraseña');
    } finally {
      setSubmitting(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4">
        <Card className="bg-[#0A0A0A] border-zinc-800 max-w-md w-full">
          <CardContent className="p-6 text-center">
            <p className="text-white mb-2">Enlace inválido</p>
            <p className="text-zinc-500 text-sm mb-4">Falta el token. Usa el enlace que recibiste por email.</p>
            <Link to="/" className="text-emerald-400 text-sm">Ir al login</Link>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src={`${process.env.PUBLIC_URL || ''}/fex-logo-light.png`}
            alt="FEX Fitness Experience"
            className="h-16 w-auto mx-auto mb-3 select-none"
            draggable="false"
          />
          <p className="text-xs uppercase tracking-widest text-zinc-500">Configura tu contraseña</p>
        </div>
        <Card className="bg-[#0A0A0A] border-zinc-800">
          <CardContent className="p-6">
            <form onSubmit={handleSubmit} className="space-y-4" data-testid="portal-setup-form">
              <div>
                <Label className="text-xs text-zinc-500 uppercase">Nueva contraseña</Label>
                <div className="relative mt-1">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" size={16} />
                  <Input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Mínimo 6 caracteres"
                    required
                    minLength={6}
                    className="pl-10 bg-zinc-900 border-zinc-700"
                    data-testid="portal-setup-password"
                  />
                </div>
              </div>
              <div>
                <Label className="text-xs text-zinc-500 uppercase">Confirmar contraseña</Label>
                <div className="relative mt-1">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" size={16} />
                  <Input
                    type="password"
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                    required
                    minLength={6}
                    className="pl-10 bg-zinc-900 border-zinc-700"
                    data-testid="portal-setup-confirm"
                  />
                </div>
              </div>
              <Button type="submit" disabled={submitting} className="w-full bg-emerald-600 hover:bg-emerald-700" data-testid="portal-setup-submit">
                {submitting ? 'Guardando…' : 'Configurar y entrar'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PortalSetupPassword;
